import { render, staticRenderFns } from "./AjouterPage.vue?vue&type=template&id=74b48539&scoped=true&"
import script from "./AjouterPage.vue?vue&type=script&lang=js&"
export * from "./AjouterPage.vue?vue&type=script&lang=js&"
import style0 from "./AjouterPage.vue?vue&type=style&index=0&id=74b48539&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b48539",
  null
  
)

export default component.exports